<div [formGroup]="formGroup()" class="row-container">
  @if (conditionItemFormControls.length > 1 && !isReadOnly()) {
    <div class="row">
      <ng-container i18n="@@ruleset.match">Match</ng-container>
      <mat-tab-group
        animationDuration="0ms"
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        class="no-content-margin"
        [selectedIndex]="selectedMatchTypeIndex()"
        (selectedIndexChange)="onMatchTypeChange($event)"
      >
        <mat-tab [label]="translations.all"></mat-tab>
        <mat-tab [label]="translations.any"></mat-tab>
      </mat-tab-group>
    </div>
  }
  <div formArrayName="groupForms">
    @for (control of conditionItemFormControls; track control; let last = $last) {
      <ng-container [formGroupName]="$index">
        <app-ruleset-criteria-group
          (addCriteria)="addCriteria.emit($event)"
          (remove)="onRemoveCriteriaGroup($index)"
          (removeCriteria)="removeCriteria.emit({ formGroup: control, index: $index })"
          (convertCriteriaItemToGroup)="onConvertToGroup($event, $index)"
          [booleanOperator]="!last ? matchType[selectedMatchTypeIndex()] : null"
          [formGroup]="control"
          [isReadOnly]="isReadOnly()"
          [shouldBeIndented]="conditionItemFormControls.length > 1"
          [propertyOptions]="propertyOptions()"
          [countryOptions]="countryOptions()"
          [locationTypeOptions]="locationTypeOptions()"
          [locationOptions]="locationOptions()"
        ></app-ruleset-criteria-group>
      </ng-container>
    }
  </div>
  @if (!isReadOnly()) {
    <div class="row row-2">
      <app-button-group>
        <app-button type="ghost" (pressed)="onAddCriteriaGroup()">
          <mat-icon>add</mat-icon>
          <ng-container i18n="@@ruleset.addcriteriagroup">Add criteria group</ng-container>
        </app-button>
      </app-button-group>
    </div>
  }
</div>
